import { render, staticRenderFns } from "./PreviewIphoneSafariSearchBar.vue?vue&type=template&id=517f2bc5&scoped=true&lang=pug&"
import script from "./PreviewIphoneSafariSearchBar.vue?vue&type=script&lang=js&"
export * from "./PreviewIphoneSafariSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./PreviewIphoneSafariSearchBar.vue?vue&type=style&index=0&id=517f2bc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f2bc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
